// How a page manager reaches the browser (SSOT for that, golden rule #1).
//
// The registry says WHICH manager a page uses; this says HOW it is loaded, and the two are
// deliberately separate. Every entry below is a literal `import()`, which is the whole point:
// a bundler can see a literal and cannot see `import(page.manager)`. With the path in a
// variable, main.js was bundled alone and every manager — plus everything they import, which
// is most of the application — was left to be fetched as raw source at runtime. Two costs
// followed, and both bit us:
//
//   the browser held TWO copies of any module the bundle also contained, each with its own
//     state: two sockets, one carrying the listeners and the other the room (realtime.js);
//   those raw files are cached for an hour under a name that never changes, so a deploy left
//     visitors running a mix of old and new for as long as their cache held.
//
// Listed by hand, six lines, because the alternative is a build-time glob that fails silently
// when it matches nothing. A new page adds its line here next to its registry entry.

const MANAGERS = {
  '/core/managers/pages/EstimatePageManager.js': () => import('./EstimatePageManager.js'),
  '/core/managers/pages/QuotePageManager.js': () => import('./QuotePageManager.js'),
  '/core/managers/pages/CheckoutPageManager.js': () => import('./CheckoutPageManager.js'),
  '/core/managers/pages/WelcomePageManager.js': () => import('./WelcomePageManager.js'),
  '/core/managers/pages/SharedQuotePageManager.js': () => import('./SharedQuotePageManager.js'),
  '/core/managers/pages/SpacePageManager.js': () => import('./SpacePageManager.js'),
  '/core/managers/pages/VerifyBankPageManager.js': () => import('./VerifyBankPageManager.js'),
  '/core/managers/pages/InvoicePayPageManager.js': () => import('./InvoicePayPageManager.js'),
};

/**
 * @param {string} manager the path the registry names
 * @returns {Promise<object|null>} the manager module, or null when the registry names one this
 *   map does not know — a page that ships without behaviour rather than breaking bootstrap
 */
export function loadManager(manager) {
  const load = MANAGERS[manager];
  if (load) return load();
  console.error(`[main] no manager registered for "${manager}"`);
  return Promise.resolve(null);
}
